const RESULT_TYPES = {
  EMAIL_UPDATE_CONFIRM: "email_update_confirm"
}

export { RESULT_TYPES }
